// Local storage utilities for Magnificent Bastards Club

export interface Player {
  id: string;
  name: string;
  teamName: string;
  handicap: number;
  image: string;
}

export interface Score {
  gross: number;
  net: number;
}

export interface Result {
  place: '1st' | '2nd' | '3rd';
  playerId: string;
  individualPoints: number;
  teamPoints: number;
  totalPoints: number;
}

export interface LeagueData {
  players: Record<string, Player>;
  scores: Record<string, Record<number, Score>>; // playerId -> week -> score
  individualPoints: Record<string, Record<number, number>>; // playerId -> week -> points
  teamPoints: Record<string, Record<number, number>>; // teamName -> week -> points
  results?: Record<string, Result[]>; // bi-weekly range (e.g., "1-2") -> results array
}

export interface WeekSchedule {
  week: number;
  date: string;
  course: string;
  pairings: Array<{ player1: string; player2: string }>;
  byes: string[];
}

const STORAGE_KEY = 'mbc_league_data';

const defaultPlayers: Player[] = [
  { id: 'steve', name: 'Steve', teamName: 'Hozel Rockets', handicap: 3, image: 'https://public.readdy.ai/ai/img_res/d8eb832b7c7b3f2f3401565d282547fd.jpg' },
  { id: 'jake', name: 'Jake', teamName: '2 Putt Shakur', handicap: 4, image: 'https://readdy.ai/api/search-image?query=Professional%20male%20golfer%20in%20modern%20athletic%20wear%20with%20golf%20club%2C%20confident%20stance%2C%20studio%20portrait%20with%20dramatic%20lighting%2C%20dark%20background%20with%20subtle%20green%20accents%2C%20photorealistic%2C%20high%20detail%2C%20sports%20photography%20style&width=400&height=400&seq=jake&orientation=squarish' },
  { id: 'benny', name: 'Benny', teamName: 'Ballz of Glory', handicap: 5, image: 'https://readdy.ai/api/search-image?query=Professional%20male%20golfer%20in%20modern%20athletic%20wear%20with%20golf%20club%2C%20confident%20stance%2C%20studio%20portrait%20with%20dramatic%20lighting%2C%20dark%20background%20with%20subtle%20green%20accents%2C%20photorealistic%2C%20high%20detail%2C%20sports%20photography%20style&width=400&height=400&seq=benny&orientation=squarish' },
  { id: 'tanner', name: 'Tanner', teamName: 'High-Flyin\' Hacks', handicap: 4, image: 'https://readdy.ai/api/search-image?query=Professional%20male%20golfer%20in%20modern%20athletic%20wear%20holding%20golf%20club%2C%20confident%20pose%2C%20studio%20portrait%20with%20dramatic%20lighting%2C%20dark%20background%20with%20subtle%20green%20accents%2C%20photorealistic%2C%20high%20detail%2C%20sports%20photography%20style&width=400&height=400&seq=tanner&orientation=squarish' },
  { id: 'tom', name: 'Tom', teamName: 'Hookers and Shanks', handicap: 6, image: 'https://readdy.ai/api/search-image?query=Professional%20male%20golfer%20in%20modern%20athletic%20wear%20with%20golf%20club%2C%20confident%20expression%2C%20studio%20portrait%20with%20dramatic%20lighting%2C%20dark%20background%20with%20subtle%20green%20accents%2C%20photorealistic%2C%20high%20detail%2C%20sports%20photography%20style&width=400&height=400&seq=tom&orientation=squarish' },
  { id: 'joshe', name: 'Josh E.', teamName: 'Tee Bagger', handicap: 2, image: 'https://readdy.ai/api/search-image?query=Professional%20male%20golfer%20in%20modern%20athletic%20wear%20holding%20driver%2C%20confident%20expression%2C%20studio%20portrait%20with%20dramatic%20lighting%2C%20dark%20background%20with%20subtle%20green%20accents%2C%20photorealistic%2C%20high%20detail%2C%20sports%20photography%20style&width=400&height=400&seq=joshe&orientation=squarish' },
  { id: 'todd', name: 'Todd', teamName: 'Sofa King Long', handicap: 7, image: 'https://readdy.ai/api/search-image?query=Professional%20male%20golfer%20in%20modern%20athletic%20wear%20with%20golf%20equipment%2C%20confident%20pose%2C%20studio%20portrait%20with%20dramatic%20lighting%2C%20dark%20background%20with%20subtle%20green%20accents%2C%20photorealistic%2C%20high%20detail%2C%20sports%20photography%20style&width=400&height=400&seq=todd&orientation=squarish' },
  { id: 'payton', name: 'Payton', teamName: 'Caddyshagger Deluxe', handicap: 3, image: 'https://readdy.ai/api/search-image?query=Professional%20female%20golfer%20in%20modern%20athletic%20wear%20holding%20iron%20club%2C%20confident%20stance%2C%20studio%20portrait%20with%20dramatic%20lighting%2C%20dark%20background%20with%20subtle%20green%20accents%2C%20photorealistic%2C%20high%20detail%2C%20sports%20photography%20style&width=400&height=400&seq=payton&orientation=squarish' },
  { id: 'riley', name: 'Riley', teamName: 'Fore Skin Crew', handicap: 7, image: 'https://readdy.ai/api/search-image?query=Professional%20male%20golfer%20in%20modern%20athletic%20wear%20holding%20driver%20club%2C%20confident%20stance%2C%20studio%20portrait%20with%20dramatic%20lighting%2C%20dark%20background%20with%20subtle%20green%20accents%2C%20photorealistic%2C%20high%20detail%2C%20sports%20photography%20style&width=400&height=400&seq=riley&orientation=squarish' },
  { id: 'braxton', name: 'Braxton', teamName: 'Choke Up Chump', handicap: 7, image: 'https://readdy.ai/api/search-image?query=Professional%20male%20golfer%20in%20modern%20athletic%20wear%20with%20golf%20club%2C%20confident%20expression%2C%20studio%20portrait%20with%20dramatic%20lighting%2C%20dark%20background%20with%20subtle%20green%20accents%2C%20photorealistic%2C%20high%20detail%2C%20sports%20photography%20style&width=400&height=400&seq=braxton&orientation=squarish' },
  { id: 'zoe', name: 'Zoe', teamName: 'Mulligans Island', handicap: 6, image: 'https://readdy.ai/api/search-image?query=Professional%20female%20golfer%20in%20modern%20athletic%20wear%20holding%20wedge%2C%20confident%20expression%2C%20studio%20portrait%20with%20dramatic%20lighting%2C%20dark%20background%20with%20subtle%20green%20accents%2C%20photorealistic%2C%20high%20detail%2C%20sports%20photography%20style&width=400&height=400&seq=zoe&orientation=squarish' },
  { id: 'joshm', name: 'Josh M.', teamName: 'Stroke and Poke', handicap: 5, image: 'https://readdy.ai/api/search-image?query=Professional%20male%20golfer%20in%20modern%20athletic%20wear%20with%20golf%20equipment%2C%20confident%20pose%2C%20studio%20portrait%20with%20dramatic%20lighting%2C%20dark%20background%20with%20subtle%20green%20accents%2C%20photorealistic%2C%20high%20detail%2C%20sports%20photography%20style&width=400&height=400&seq=joshm&orientation=squarish' },
];

export const weekSchedule: WeekSchedule[] = [
  { week: 1, date: '2025-11-13', course: 'Pebble Beach (Front 9)', pairings: [{ player1: 'tanner', player2: 'benny' }, { player1: 'joshe', player2: 'joshm' }, { player1: 'payton', player2: 'tom' }], byes: ['steve', 'jake', 'zoe', 'todd', 'riley', 'braxton'] },
  { week: 2, date: '2025-11-20', course: 'Pebble Beach (Front 9)', pairings: [{ player1: 'steve', player2: 'jake' }, { player1: 'zoe', player2: 'riley' }, { player1: 'todd', player2: 'braxton' }], byes: ['tanner', 'benny', 'payton', 'tom', 'joshe', 'joshm'] },
  { week: 3, date: '2025-12-04', course: 'Panther Lakes (Front 9)', pairings: [{ player1: 'tanner', player2: 'joshm' }, { player1: 'benny', player2: 'braxton' }, { player1: 'payton', player2: 'steve' }], byes: ['jake', 'zoe', 'joshe', 'todd', 'riley', 'tom'] },
  { week: 4, date: '2025-12-11', course: 'Panther Lakes (Front 9)', pairings: [{ player1: 'jake', player2: 'tom' }, { player1: 'joshe', player2: 'todd' }, { player1: 'riley', player2: 'steve' }], byes: ['benny', 'tanner', 'payton', 'braxton', 'zoe', 'joshm'] },
  { week: 5, date: '2025-12-18', course: 'Oslo Golfklubb (Front 9)', pairings: [{ player1: 'todd', player2: 'payton' }, { player1: 'riley', player2: 'braxton' }, { player1: 'zoe', player2: 'joshm' }], byes: ['steve', 'jake', 'benny', 'tanner', 'tom', 'joshe'] },
  { week: 6, date: '2026-01-08', course: 'Oslo Golfklubb (Front 9)', pairings: [{ player1: 'steve', player2: 'benny' }, { player1: 'jake', player2: 'tanner' }, { player1: 'tom', player2: 'joshe' }], byes: ['todd', 'payton', 'riley', 'braxton', 'zoe', 'joshm'] },
  { week: 7, date: '2026-01-15', course: 'Bay Hill (Front 9)', pairings: [{ player1: 'todd', player2: 'riley' }, { player1: 'payton', player2: 'braxton' }, { player1: 'zoe', player2: 'steve' }], byes: ['jake', 'benny', 'tanner', 'tom', 'joshe', 'joshm'] },
  { week: 8, date: '2026-01-22', course: 'Bay Hill (Front 9)', pairings: [{ player1: 'joshm', player2: 'jake' }, { player1: 'benny', player2: 'joshe' }, { player1: 'tanner', player2: 'tom' }], byes: ['steve', 'todd', 'payton', 'riley', 'braxton', 'zoe'] },
  { week: 9, date: '2026-01-29', course: 'Banff Springs (Front 9)', pairings: [{ player1: 'todd', player2: 'zoe' }, { player1: 'payton', player2: 'riley' }, { player1: 'braxton', player2: 'joshm' }], byes: ['steve', 'jake', 'benny', 'tanner', 'tom', 'joshe'] },
  { week: 10, date: '2026-02-05', course: 'Banff Springs (Front 9)', pairings: [{ player1: 'steve', player2: 'tanner' }, { player1: 'jake', player2: 'benny' }, { player1: 'tom', player2: 'todd' }], byes: ['joshe', 'payton', 'riley', 'braxton', 'zoe', 'joshm'] },
  { week: 11, date: '2026-02-12', course: 'St Andrews Old (Front 9)', pairings: [{ player1: 'joshe', player2: 'payton' }, { player1: 'riley', player2: 'joshm' }, { player1: 'braxton', player2: 'zoe' }], byes: ['steve', 'jake', 'benny', 'tanner', 'tom', 'todd'] },
  { week: 12, date: '2026-02-19', course: 'St Andrews Old (Front 9)', pairings: [{ player1: 'benny', player2: 'tom' }, { player1: 'jake', player2: 'zoe' }, { player1: 'joshe', player2: 'tanner' }], byes: ['steve', 'todd', 'payton', 'riley', 'braxton', 'joshm'] },
  { week: 13, date: '2026-02-26', course: 'Playoffs - Pebble Beach (Back 9)', pairings: [], byes: [] },
];

function initializeData(): LeagueData {
  const players: Record<string, Player> = {};
  defaultPlayers.forEach(p => {
    players[p.id] = p;
  });

  return {
    players,
    scores: {},
    individualPoints: {},
    teamPoints: {},
  };
}

export function loadLeagueData(): LeagueData {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error('Error loading league data:', error);
  }
  return initializeData();
}

export function saveLeagueData(data: LeagueData): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.error('Error saving league data:', error);
  }
}

export function resetWeek(data: LeagueData, week: number): LeagueData {
  const newData = { ...data };
  
  // Clear scores for this week
  Object.keys(newData.scores).forEach(playerId => {
    if (newData.scores[playerId][week]) {
      delete newData.scores[playerId][week];
    }
  });
  
  // Clear individual points for this week
  Object.keys(newData.individualPoints).forEach(playerId => {
    if (newData.individualPoints[playerId][week]) {
      delete newData.individualPoints[playerId][week];
    }
  });
  
  // Clear team points for this week
  Object.keys(newData.teamPoints).forEach(teamName => {
    if (newData.teamPoints[teamName][week]) {
      delete newData.teamPoints[teamName][week];
    }
  });
  
  return newData;
}

export function resetAllData(): void {
  localStorage.removeItem(STORAGE_KEY);
}

export function getNextMatchDate(): Date {
  const now = new Date();
  
  // Find the next scheduled week
  for (const week of weekSchedule) {
    const matchDate = new Date(week.date + 'T17:30:00-08:00'); // 5:30 PM PST
    if (matchDate > now) {
      return matchDate;
    }
  }
  
  // If all matches are done, return the last match date
  const lastWeek = weekSchedule[weekSchedule.length - 1];
  return new Date(lastWeek.date + 'T17:30:00-08:00');
}
